/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Expired_Subscription_SessionsInputs */

const fr_account_audit_expired_subscription_sessions = /** @type {(inputs: Account_Audit_Expired_Subscription_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement expiré mais sessions encore ouvertes`)
};

/**

* @param {Account_Audit_Expired_Subscription_SessionsInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_expired_subscription_sessions = /** @type {((inputs?: Account_Audit_Expired_Subscription_SessionsInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Expired_Subscription_SessionsInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_expired_subscription_sessions(inputs)
});